import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, mergeProps as _mergeProps, resolveDynamicComponent as _resolveDynamicComponent, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tx-boot"
}
const _hoisted_2 = { class: "tx-pubhead" }
const _hoisted_3 = { class: "tx-pubhead__inner" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "tx-pubhead__end" }
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 1,
  href: "/?cmd=web_logout",
  class: "tx-btn tx-btn--ghost tx-btn--sm"
}
const _hoisted_12 = ["aria-label", "aria-expanded"]
const _hoisted_13 = { class: "tx-pubfoot" }
const _hoisted_14 = { class: "tx-pubfoot__inner" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "tx-header" }
const _hoisted_18 = ["aria-label"]
const _hoisted_19 = ["href"]
const _hoisted_20 = ["src"]
const _hoisted_21 = ["aria-label"]
const _hoisted_22 = ["href"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "tx-header__spacer" }, null, -1 /* HOISTED */)
const _hoisted_24 = {
  key: 1,
  class: "tx-orgswitch"
}
const _hoisted_25 = { class: "tx-sr" }
const _hoisted_26 = ["value"]
const _hoisted_27 = ["value"]
const _hoisted_28 = {
  key: 2,
  class: "tx-orgswitch tx-orgswitch--static"
}
const _hoisted_29 = { class: "tx-pop" }
const _hoisted_30 = ["aria-label"]
const _hoisted_31 = {
  key: 0,
  class: "tx-dot"
}
const _hoisted_32 = { class: "tx-pop__head" }
const _hoisted_33 = {
  key: 0,
  class: "tx-muted tx-pad"
}
const _hoisted_34 = ["href", "onClick"]
const _hoisted_35 = { class: "tx-pop" }
const _hoisted_36 = ["aria-label"]
const _hoisted_37 = { class: "tx-menu__who" }
const _hoisted_38 = ["href"]
const _hoisted_39 = ["href"]
const _hoisted_40 = { href: "/?cmd=web_logout" }
const _hoisted_41 = ["aria-label"]
const _hoisted_42 = ["href", "aria-current"]
const _hoisted_43 = {
  key: 0,
  class: "tx-count"
}
const _hoisted_44 = {
  key: 0,
  class: "tx-nav__links"
}
const _hoisted_45 = ["href"]
const _hoisted_46 = { class: "tx-nav__foot" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = {
  key: 1,
  dir: "ltr"
}
const _hoisted_49 = {
  key: 0,
  class: "tx-admin",
  role: "status"
}
const _hoisted_50 = { href: "/app/support-portal-settings" }
const _hoisted_51 = { class: "tx-footer" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = {
  key: 1,
  class: "tx-footer__links"
}
const _hoisted_54 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (!$setup.state.ready)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode($setup["Loader"], {
          loading: !$setup.bootError,
          error: $setup.bootError,
          onRetry: $setup.load
        }, null, 8 /* PROPS */, ["loading", "error"])
      ]))
    : ($setup.isPublic)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createCommentVNode(" Visitors (not logged in, or logged in without portal access): public layout "),
          _createElementVNode("div", {
            class: _normalizeClass(["tx-public", { 'tx-public--menu': $setup.menuOpen }])
          }, [
            _createElementVNode("header", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("a", {
                  href: $setup.link(''),
                  "data-nav": "",
                  class: "tx-brand"
                }, [
                  _createElementVNode("img", {
                    src: $setup.state.branding.logo,
                    alt: ""
                  }, null, 8 /* PROPS */, _hoisted_5),
                  _createElementVNode("span", null, _toDisplayString($setup.state.branding.title), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_4),
                _createElementVNode("nav", {
                  class: "tx-pubnav",
                  "aria-label": $setup.state.t('land.menu')
                }, [
                  ($setup.state.publicKnowledge)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: $setup.link('knowledge'),
                        "data-nav": "",
                        class: _normalizeClass(["tx-pubnav__link", { on: $setup.route.name === 'knowledge' || $setup.route.name === 'article' }])
                      }, _toDisplayString($setup.state.t("nav.knowledge")), 11 /* TEXT, CLASS, PROPS */, _hoisted_7))
                    : _createCommentVNode("v-if", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.headerLinks, (m) => {
                    return (_openBlock(), _createElementBlock("a", _mergeProps({
                      key: m.url + m.label,
                      href: m.url,
                      class: "tx-pubnav__link"
                    }, m.new_tab ? { target: '_blank', rel: 'noopener' } : {}), [
                      _createTextVNode(_toDisplayString($setup.menuLabel(m)), 1 /* TEXT */),
                      (m.external)
                        ? (_openBlock(), _createBlock($setup["Icon"], {
                            key: 0,
                            name: "external",
                            size: "12"
                          }))
                        : _createCommentVNode("v-if", true)
                    ], 16 /* FULL_PROPS */, _hoisted_8))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 8 /* PROPS */, _hoisted_6),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "tx-langbtn",
                    onClick: $setup.toggleLang
                  }, _toDisplayString($setup.state.t("land.language")), 1 /* TEXT */),
                  ($setup.state.isGuest)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: $setup.loginUrl(),
                        class: "tx-btn tx-btn--primary tx-btn--sm"
                      }, [
                        _createVNode($setup["Icon"], {
                          name: "login",
                          size: "16"
                        }),
                        _createTextVNode(_toDisplayString($setup.state.t("land.login")), 1 /* TEXT */)
                      ], 8 /* PROPS */, _hoisted_10))
                    : (_openBlock(), _createElementBlock("a", _hoisted_11, _toDisplayString($setup.state.t("land.logout")), 1 /* TEXT */)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "tx-iconbtn tx-pubhead__burger",
                    "aria-label": $setup.state.t('land.menu'),
                    "aria-expanded": $setup.menuOpen,
                    onClick: _cache[0] || (_cache[0] = $event => ($setup.menuOpen = !$setup.menuOpen))
                  }, [
                    _createVNode($setup["Icon"], {
                      name: $setup.menuOpen ? 'x' : 'menu'
                    }, null, 8 /* PROPS */, ["name"])
                  ], 8 /* PROPS */, _hoisted_12)
                ])
              ])
            ]),
            _createElementVNode("main", {
              class: "tx-pubmain",
              onClick: _cache[1] || (_cache[1] = $event => ($setup.menuOpen = false))
            }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent($setup.publicView), {
                key: $setup.route.name + ($setup.route.params.id || '')
              }))
            ]),
            _createElementVNode("footer", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", null, _toDisplayString($setup.state.branding.footer_text || $setup.state.branding.title), 1 /* TEXT */),
                ($setup.footerLinks.length)
                  ? (_openBlock(), _createElementBlock("nav", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.footerLinks, (m) => {
                        return (_openBlock(), _createElementBlock("a", _mergeProps({
                          key: m.url + m.label,
                          href: m.url
                        }, m.new_tab ? { target: '_blank', rel: 'noopener' } : {}), _toDisplayString($setup.menuLabel(m)), 17 /* TEXT, FULL_PROPS */, _hoisted_16))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createVNode($setup["ChatWidget"], {
              context: "portal",
              lang: $setup.state.lang
            }, null, 8 /* PROPS */, ["lang"])
          ], 2 /* CLASS */)
        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createCommentVNode(" Customers: application layout "),
          _createElementVNode("div", {
            class: _normalizeClass(["tx-shell", { 'tx-shell--nav-open': $setup.navOpen }])
          }, [
            _createElementVNode("header", _hoisted_17, [
              _createElementVNode("button", {
                class: "tx-iconbtn tx-header__menu",
                "aria-label": $setup.state.t('land.menu'),
                onClick: _cache[2] || (_cache[2] = $event => ($setup.navOpen = !$setup.navOpen))
              }, [
                _createVNode($setup["Icon"], {
                  name: $setup.navOpen ? 'x' : 'menu'
                }, null, 8 /* PROPS */, ["name"])
              ], 8 /* PROPS */, _hoisted_18),
              _createElementVNode("a", {
                href: $setup.link(''),
                "data-nav": "",
                class: "tx-brand"
              }, [
                _createElementVNode("img", {
                  src: $setup.state.branding.logo,
                  alt: ""
                }, null, 8 /* PROPS */, _hoisted_20),
                _createElementVNode("span", null, _toDisplayString($setup.state.branding.title), 1 /* TEXT */)
              ], 8 /* PROPS */, _hoisted_19),
              ($setup.headerLinks.length)
                ? (_openBlock(), _createElementBlock("nav", {
                    key: 0,
                    class: "tx-hlinks",
                    "aria-label": $setup.state.t('land.menu')
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.headerLinks, (m) => {
                      return (_openBlock(), _createElementBlock("a", _mergeProps({
                        key: m.url + m.label,
                        href: m.url
                      }, m.new_tab ? { target: '_blank', rel: 'noopener' } : {}), [
                        _createTextVNode(_toDisplayString($setup.menuLabel(m)), 1 /* TEXT */),
                        (m.external)
                          ? (_openBlock(), _createBlock($setup["Icon"], {
                              key: 0,
                              name: "external",
                              size: "12"
                            }))
                          : _createCommentVNode("v-if", true)
                      ], 16 /* FULL_PROPS */, _hoisted_22))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 8 /* PROPS */, _hoisted_21))
                : _createCommentVNode("v-if", true),
              _hoisted_23,
              ($setup.state.orgs.length > 1)
                ? (_openBlock(), _createElementBlock("label", _hoisted_24, [
                    _createVNode($setup["Icon"], {
                      name: "building",
                      size: "16"
                    }),
                    _createElementVNode("span", _hoisted_25, _toDisplayString($setup.state.t("nav.organization")), 1 /* TEXT */),
                    _createElementVNode("select", {
                      value: $setup.state.org,
                      onChange: _cache[3] || (_cache[3] = $event => ($setup.switchOrg($event.target.value)))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.orgs, (o) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: o.customer,
                          value: o.customer
                        }, _toDisplayString(o.customer_name), 9 /* TEXT, PROPS */, _hoisted_27))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_26)
                  ]))
                : ($setup.state.orgs.length === 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                      _createVNode($setup["Icon"], {
                        name: "building",
                        size: "16"
                      }),
                      _createTextVNode(_toDisplayString($setup.state.orgs[0].customer_name), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("button", {
                  class: "tx-iconbtn",
                  "aria-label": $setup.state.t('nav.notifications'),
                  onClick: $setup.toggleBell
                }, [
                  _createVNode($setup["Icon"], { name: "bell" }),
                  ($setup.state.unreadNotifications)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString($setup.state.unreadNotifications > 9 ? "9+" : $setup.state.unreadNotifications), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ], 8 /* PROPS */, _hoisted_30),
                ($setup.bellOpen)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "tx-pop__panel tx-notifs",
                      onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("strong", null, _toDisplayString($setup.state.t("nav.notifications")), 1 /* TEXT */),
                        _createElementVNode("button", {
                          class: "tx-link",
                          onClick: $setup.markAll
                        }, _toDisplayString($setup.state.t("common.markAllRead")), 1 /* TEXT */)
                      ]),
                      (!$setup.notifications.length)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString($setup.state.t("common.none")), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.notifications, (n) => {
                        return (_openBlock(), _createElementBlock("a", {
                          key: n.name,
                          href: $setup.notifLink(n),
                          "data-nav": "",
                          class: _normalizeClass(["tx-notif", { 'tx-notif--unread': !n.read }]),
                          onClick: $event => ($setup.openNotif(n))
                        }, [
                          _createElementVNode("span", null, _toDisplayString(n.subject), 1 /* TEXT */),
                          _createElementVNode("small", null, _toDisplayString($setup.fmtDate(n.creation, true)), 1 /* TEXT */)
                        ], 10 /* CLASS, PROPS */, _hoisted_34))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("button", {
                  class: "tx-avatar",
                  "aria-label": $setup.state.user?.full_name,
                  onClick: _cache[5] || (_cache[5] = $event => ($setup.menuOpen = !$setup.menuOpen))
                }, _toDisplayString($setup.initials), 9 /* TEXT, PROPS */, _hoisted_36),
                ($setup.menuOpen)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "tx-pop__panel tx-menu",
                      onClick: _cache[6] || (_cache[6] = $event => ($setup.menuOpen = false))
                    }, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("strong", null, _toDisplayString($setup.state.user?.full_name), 1 /* TEXT */),
                        _createElementVNode("small", null, _toDisplayString($setup.state.user?.email), 1 /* TEXT */)
                      ]),
                      _createElementVNode("a", {
                        href: $setup.link('settings'),
                        "data-nav": ""
                      }, [
                        _createVNode($setup["Icon"], {
                          name: "settings",
                          size: "16"
                        }),
                        _createTextVNode(_toDisplayString($setup.state.t("nav.settings")), 1 /* TEXT */)
                      ], 8 /* PROPS */, _hoisted_38),
                      ($setup.state.agentUrl)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: $setup.state.agentUrl
                          }, [
                            _createVNode($setup["Icon"], {
                              name: "headset",
                              size: "16"
                            }),
                            _createTextVNode(_toDisplayString($setup.state.t("nav.agent")), 1 /* TEXT */)
                          ], 8 /* PROPS */, _hoisted_39))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("a", _hoisted_40, [
                        _createVNode($setup["Icon"], {
                          name: "logout",
                          size: "16"
                        }),
                        _createTextVNode(_toDisplayString($setup.state.t("nav.logout")), 1 /* TEXT */)
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createElementVNode("nav", {
              class: "tx-nav",
              "aria-label": $setup.state.branding.title,
              onClick: _cache[7] || (_cache[7] = $event => ($setup.navOpen = false))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.navItems, (item) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: item.name,
                  href: $setup.link(item.path),
                  "data-nav": "",
                  class: _normalizeClass(["tx-nav__item", { 'tx-nav__item--active': $setup.isActive(item) }]),
                  "aria-current": $setup.isActive(item) ? 'page' : null
                }, [
                  _createVNode($setup["Icon"], {
                    name: item.icon
                  }, null, 8 /* PROPS */, ["name"]),
                  _createElementVNode("span", null, _toDisplayString($setup.state.t(item.label)), 1 /* TEXT */),
                  (item.name === 'conversations' && $setup.state.unreadMessages)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString($setup.state.unreadMessages), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ], 10 /* CLASS, PROPS */, _hoisted_42))
              }), 128 /* KEYED_FRAGMENT */)),
              ($setup.headerLinks.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.headerLinks, (m) => {
                      return (_openBlock(), _createElementBlock("a", _mergeProps({
                        key: m.url + m.label,
                        href: m.url,
                        class: "tx-nav__item"
                      }, m.new_tab ? { target: '_blank', rel: 'noopener' } : {}), [
                        _createVNode($setup["Icon"], { name: "external" }),
                        _createElementVNode("span", null, _toDisplayString($setup.menuLabel(m)), 1 /* TEXT */)
                      ], 16 /* FULL_PROPS */, _hoisted_45))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_46, [
                ($setup.state.branding.support_email)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString($setup.state.branding.support_email), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                ($setup.state.branding.support_phone)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString($setup.state.branding.support_phone), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ])
            ], 8 /* PROPS */, _hoisted_41),
            _createElementVNode("div", {
              class: "tx-scrim",
              onClick: _cache[8] || (_cache[8] = $event => ($setup.navOpen = false))
            }),
            _createElementVNode("main", {
              class: _normalizeClass(["tx-main", { 'tx-main--landing': $setup.showLanding }]),
              onClick: $setup.closePops
            }, [
              ($setup.state.adminWarnings.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                    _createVNode($setup["Icon"], { name: "alert" }),
                    _createElementVNode("div", null, [
                      _createElementVNode("strong", null, _toDisplayString($setup.state.t("admin.warnings")), 1 /* TEXT */),
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.adminWarnings, (w) => {
                          return (_openBlock(), _createElementBlock("li", { key: w }, _toDisplayString(w), 1 /* TEXT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _createElementVNode("a", _hoisted_50, _toDisplayString($setup.state.t("admin.settings")), 1 /* TEXT */)
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              (_openBlock(), _createBlock(_resolveDynamicComponent($setup.view), { key: $setup.viewKey })),
              _createElementVNode("footer", _hoisted_51, [
                ($setup.state.branding.footer_text)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString($setup.state.branding.footer_text), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                ($setup.footerLinks.length)
                  ? (_openBlock(), _createElementBlock("nav", _hoisted_53, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.footerLinks, (m) => {
                        return (_openBlock(), _createElementBlock("a", _mergeProps({
                          key: m.url + m.label,
                          href: m.url
                        }, m.new_tab ? { target: '_blank', rel: 'noopener' } : {}), _toDisplayString($setup.menuLabel(m)), 17 /* TEXT, FULL_PROPS */, _hoisted_54))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ], 2 /* CLASS */),
            ($setup.state.toast)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["tx-toast", 'tx-toast--' + $setup.state.toast.kind]),
                  role: "status"
                }, _toDisplayString($setup.state.toast.message), 3 /* TEXT, CLASS */))
              : _createCommentVNode("v-if", true),
            _createVNode($setup["ChatWidget"], {
              context: "portal",
              organization: $setup.state.org,
              lang: $setup.state.lang
            }, null, 8 /* PROPS */, ["organization", "lang"])
          ], 2 /* CLASS */)
        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}